import * as yup from 'yup';

export const minOrderSchema = yup.object().shape({
  delivery: yup.object().shape({
    amount: yup
      .number()
      .min(0, 'min_order_or_equal_to_0')
      .nullable(true)
      .transform((value) => (isNaN(value) ? null : value)),
    enabled: yup.boolean(),
  }),
  pickup: yup.object().shape({
    amount: yup
      .number()
      .min(0, 'min_order_or_equal_to_0')
      .nullable(true)
      .transform((value) => (isNaN(value) ? null : value)),
    enabled: yup.boolean(),
  }),
});

export const deliveryLimitsSchema = yup.object().shape({
  maxDeliveryFee: yup
    .number()
    .min(0, 'min_order_or_equal_to_0')
    .nullable(true)
    .transform((value) => (isNaN(value) ? null : value)),
  maxDeliveryRadius: yup
    .number()
    .min(0, 'min_order_or_equal_to_0')
    .nullable(true)
    .transform((value) => (isNaN(value) ? null : value)),
});

const dropoffVerificationSchema = yup.object().shape({
  leaveAtDoor: yup.object().shape({
    enabled: yup.boolean(),
    picture: yup.boolean(),
  }),
  meetAtDoor: yup.object().shape({
    enabled: yup.boolean(),
    signature: yup.boolean(),
    pinCode: yup.boolean(),
    barCode: yup.boolean(),
  }),
});

export const mainSettingsInfo = yup.object().shape({
  minOrderObj: minOrderSchema,
  merchantSettings: yup.object().shape({
    applePayEnabled: yup.boolean(),
    googlePayEnabled: yup.boolean(),
  }),
  minOrder: yup
    .number()
    .min(0, 'min_order_or_equal_to_0')
    .nullable(true)
    .transform((value) => (isNaN(value) ? null : value)),
  deliveryBy: yup.array().of(
    yup.object().shape({
      dropoffVerification: dropoffVerificationSchema,
    })
  ),
  delivery: yup.boolean(),
  url: yup.string().required('field_is_required_'),
  pickup: yup.boolean(),
  curbsidePickup: yup.boolean(),
  autoConfirm: yup.number(),
  baseUrl: yup.string().nullable(),
});

export const deliveryServiceInfo = yup.object().shape({
  deliveryLimits: deliveryLimitsSchema,
  deliveryBy: yup.array().of(
    yup.object().shape({
      maxDeliveryFee: yup
        .number()
        .min(0, 'max_delivery_equal_to_0')
        .transform((value) => (isNaN(value) ? null : value))
        .nullable(),
      dropoffVerification: dropoffVerificationSchema,
    })
  ),
  deliveryFee: yup
    .number()
    .min(0, 'delivery_fee_equal_to_0')
    .transform((value) => (isNaN(value) ? -1 : value))
    .required('field_is_required_'),
  radius: yup
    .number()
    .min(1, 'radius_must_equal_to_1')
    .transform((value) => (isNaN(value) ? 0 : value))
    .required('field_is_required_'),
  delivery: yup.boolean(),
  deliveryFlatFeeSettings: yup.object().shape({
    flatFeeEnabled: yup.boolean(),
    deliveryRateSettings: yup.array().of(
      yup.object().shape({
        deliveryRadiusFrom: yup.number().required('field_is_required_'),
        deliveryRadiusTo: yup
          .number()
          .min(1, 'radius_must_equal_to_1')
          .transform((value) => (isNaN(value) ? 0 : value))
          .required('field_is_required_'),
        deliveryPrice: yup.number(),
        providerLimitFeeEnabled: false,
        providerLimitedFee: 0,
      })
    ),
  }),
  strategyId: yup.string(),
});

export const deliveryServiceInHouseInfo = yup.object().shape({
  deliveryLimits: deliveryLimitsSchema,
  deliveryBy: yup.array().of(
    yup.object().shape({
      maxDeliveryFee: yup
        .number()
        .min(0, 'max_delivery_equal_to_0')
        .transform((value) => (isNaN(value) ? null : value))
        .nullable(),
      dropoffVerification: dropoffVerificationSchema,
    })
  ),
  deliveryFee: yup
    .number()
    .min(0, 'delivery_fee_equal_to_0')
    .transform((value) => (isNaN(value) ? -1 : value))
    .required('field_is_required_'),
  radius: yup
    .number()
    .min(1, 'radius_must_equal_to_1')
    .transform((value) => (isNaN(value) ? 0 : value))
    .required('field_is_required_'),
  delivery: yup.boolean(),
  deliveryFlatFeeSettings: yup.object().shape({
    flatFeeEnabled: yup.boolean(),
    deliveryRateSettings: yup.array().of(
      yup.object().shape({
        deliveryRadiusFrom: yup.number().required('field_is_required_'),
        deliveryRadiusTo: yup
          .number()
          .min(1, 'radius_must_equal_to_1')
          .transform((value) => (isNaN(value) ? 0 : value))
          .required('field_is_required_'),
        deliveryPrice: yup.number(),
      })
    ),
  }),
});

export const deliveryServiceDisabledInfo = yup.object().shape({
  deliveryBy: yup.array().of(
    yup.object().shape({
      maxDeliveryFee: yup
        .number()
        .min(0, 'max_delivery_equal_to_0')
        .transform((value) => (isNaN(value) ? null : value))
        .nullable(),
      dropoffVerification: dropoffVerificationSchema,
    })
  ),
  deliveryFee: yup.number(),
  radius: yup.number(),
  delivery: yup.boolean(),
});
